/*
 * @Author: chenlin
 * @Date: 2019-11-22 09:59:51
 * @LastEditors: chenlin
 * @LastEditTime: 2020-04-09 14:02:59
 * @Description: 在此添加描述
 */
export function formatDate (time, fmt) {
  let date = new Date(time)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    let str = o[k] + ''
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      )
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}
/**
 * 获取当前系统时间的年份
 */
export function getNowYear () {
  let date = new Date()
  let year = date.getFullYear()
  return year
}
/**
 *用于高级查询列表格式化时间
 *
 * @export
 * @param {*} data
 * @param {*} key
 * @param {*} columnList
 * @returns
 */
export function formatterDate (data, key, columnList) {
  for (const item of columnList) {
    if (item.type === 'DateTime' && item.code === key.property) {
      if (typeof data[key.property] !== 'undefined' && data[key.property] !== null) {
        return formatDate(data[key.property], 'yyyy-MM-dd hh:mm:ss')
      }
    } else if (item.type === 'Date' && item.code === key.property) {
      if (typeof data[key.property] !== 'undefined' && data[key.property] !== null) {
        return formatDate(data[key.property], 'yyyy-MM-dd')
      }
    } else if (item.type === 'Time' && item.code === key.property) {
      if (typeof data[key.property] !== 'undefined' && data[key.property] !== null) {
        return formatDate(data[key.property], 'hh:mm:ss')
      }
    }
  }
}
